var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topbar"},[_c('div',{staticClass:"logo"},[_c('a',{attrs:{"href":"https://www.heigit.org"}},[_c('heigitlogo')],1)]),_c('div',{staticClass:"page-title"},[_vm._v(" [WIP] Isochrones 4 health access ")])])}
var staticRenderFns = []

export { render, staticRenderFns }